const FINANCES = ['finances', 'pricing-plans', 'finances/:id'];

export default FINANCES;
